// extracted by mini-css-extract-plugin
export default {"container":"JD-z","finalSalePdpEnhancements":"KD-z"};